module.exports = __webpack_public_path__ + "img/web_customers_say_01.00bbc0c9.jpg";